// instrumentation-client.js
// PostHog removed - using Google Analytics and GTM instead